/**
 * Portal helpers shared by the hub and the admin SPA (imported as
 * `@verybigthings/trackframe-shared/portal`). Own subpath, like `./tracks`,
 * so consumers don't pull the schemas barrel into edge runtimes.
 */
/**
 * HUB-125 D2/D4: the portal root — `/`, or the SPA origin (`APP_BASE_URL`)
 * with no path and no query — is where a sign-in lands by DEFAULT, not a
 * page the user asked for. The hub applies this to `return_to` (login and
 * sign-out: a root `return_to` yields to the landing URL); the admin SPA
 * applies it to the landing URL itself (a landing URL that IS the root must
 * not redirect `/` to `/`).
 */
export function isPortalRoot(url, appBaseUrl) {
    if (url === '/')
        return true;
    if (!appBaseUrl)
        return false;
    try {
        const parsed = new URL(url);
        return parsed.origin === new URL(appBaseUrl).origin && parsed.pathname === '/' && parsed.search === '';
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=portal.js.map